import Link from '@commons/components/Link';
import Flex from '@commons/containers/Flex';
import type { DrupalBlock, DrupalLink } from '@commons/types/drupal';

import styles from './index.module.scss';

// Type definition for the BreadCrumbs block properties.

type Props = DrupalBlock<{
  links?: DrupalLink[];
  currentPage?: DrupalLink;
}>;

/**
 * BreadCrumbs system block component.
 */

const BreadCrumbsBlock = ({ content }: Props) => {
  const { links = [], currentPage } = content;

  const breadcrumbs = [...links];

  if (currentPage) {
    breadcrumbs.push(currentPage);
  }

  const renderedBreadcrumbs = breadcrumbs.map(({ url, text }, index) => (
    <Link href={url} className={styles.link} key={index}>
      {text}
    </Link>
  ));

  return (
    <Flex width={12} gap="sm" className={styles.wrapper}>
      {renderedBreadcrumbs}
    </Flex>
  );
};

export default BreadCrumbsBlock;
